import type { PropsWithChildren } from "react";
import React from "react";

import { verticalProductCardStyle } from "./VerticalProductCard.css";
import type { ProductCardDataType } from "./types";

type Props = PropsWithChildren & {
  product: ProductCardDataType;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
};

export const VerticalProductCardRoot: React.FC<Props> = ({
  children,
  product,
  onClick
}) => {
  return (
    <a
      href={product.href}
      title={product.productName}
      className={verticalProductCardStyle}
      onClick={(e) => onClick?.(e)}
      data-testid="vertical-product-card"
      data-event-intersection="productImpression"
      data-sku={product.sku}
    >
      {children}
    </a>
  );
};
